import React from "react"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faPlus, faTrash } from "@fortawesome/free-solid-svg-icons"
import { COLORS } from "../../../utilities/Constants"
import { generalStyles as gs } from "../../styles/styles"
import AdresseV2 from "./AdresseV2"

const styles = {
	block: {
		borderTop: `1px solid ${COLORS.border}`,
		paddingTop: 18,
		marginTop: 18,
	},
	blockHead: {
		display: "flex",
		alignItems: "center",
		justifyContent: "space-between",
		minHeight: 18,
		marginBottom: 14,
	},
	blockLabel: {
		fontSize: 11,
		fontWeight: 600,
		color: COLORS.textLight,
		letterSpacing: "0.08em",
		textTransform: "uppercase",
	},
	delBtn: {
		display: "inline-flex",
		alignItems: "center",
		justifyContent: "center",
		width: 28,
		height: 28,
		borderRadius: 8,
		border: `1px solid ${COLORS.border}`,
		backgroundColor: COLORS.surface,
		color: COLORS.danger,
		cursor: "pointer",
		fontSize: 12,
	},
	empty: { color: COLORS.textLight, fontSize: 13, marginBottom: 14 },
}

// Reusable V2 "Adresses" section. `updateAdresse(index, key, value, whole)`.
// `deleteAdresse(index)` optionnel : si fourni, un bouton corbeille par adresse.
// `max` optionnel : n'affiche que les `max` premières adresses et retire
// « Ajouter » une fois atteint (les suivantes restent intactes au save).
const EntiteAdressesV2 = ({
	adresses = [],
	updateAdresse,
	addAdresse,
	deleteAdresse,
	showExtraData = false,
	max,
}) => {
	const visibles = max ? adresses.slice(0, max) : adresses
	return (
		<div style={gs.card}>
			<div style={gs.cardTitle}>{max === 1 ? "Adresse" : "Adresses"}</div>
			{adresses.length === 0 && (
				<div style={styles.empty}>Aucune adresse enregistrée.</div>
			)}
			{visibles.map((adr, index) => (
				<div
					key={adr.id || `new-${index}`}
					style={index === 0 ? {} : styles.block}
				>
					{(visibles.length > 1 || deleteAdresse) && (
						<div style={styles.blockHead}>
							{visibles.length > 1 ? (
								<span style={styles.blockLabel}>
									Adresse {index + 1}
								</span>
							) : (
								<span />
							)}
							{deleteAdresse && (
								<button
									type="button"
									style={styles.delBtn}
									onClick={() => deleteAdresse(index)}
									title="Supprimer l'adresse"
								>
									<FontAwesomeIcon icon={faTrash} />
								</button>
							)}
						</div>
					)}
					<AdresseV2
						adresse={adr}
						update={(key, value, whole) =>
							updateAdresse(index, key, value, whole)
						}
						showExtraData={showExtraData}
					/>
				</div>
			))}
			{!(max && adresses.length >= max) && (
				<button
					type="button"
					style={{ ...gs.addBtn, marginTop: 18 }}
					onClick={addAdresse}
				>
					<FontAwesomeIcon icon={faPlus} />
					Ajouter une adresse
				</button>
			)}
		</div>
	)
}

export default EntiteAdressesV2
